import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { destroy } from 'redux-form';
import ContentWrapper from '../components/content-wrapper';
import { LargePrimaryButton, } from '../components/button';
import TitledComponent from '../components/titled-component';
import { connect } from 'react-redux';

import defaultAvatar from '../assets/icon/tou_geren_icon@3x.png';
import infoIcon from '../assets/icon/geren_geren_icon@3x.png';
import reportIcon from '../assets/icon/baogao_geren_icon@3x.png';
import settingIcon from '../assets/icon/shezhi_geren_icon@3x.png';
import reportImage from '../assets/img/yiliao_geren_icon@3x.png';
import { refreshUserInfo, setMedicalHistoryInitial } from '../actions/user';
import { UPDATE_INFO_FORM_NAME } from './update-info';
import { MEDICAL_HISTORY_FORM_NAME } from './medical-history';
import { USER_INFO_PLACEHOLDER } from '../reducers/user';
import { calculateBMI } from '../components/util';

const Wrapper = styled(ContentWrapper)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
`;

const Gap = styled.div`
  background: #f2f2f2;
  height: 20px;
  flex-grow: 0;
`;

const Card = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  background: white;
`;

const CardTitle = styled.div`
  display: flex;
  align-items: center;
  height: 84px;
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
`;

CardTitle.IconContainer = styled.div`
  width: ${30 + 54 + 39}px;
  flex-shrink: 0;
`;

CardTitle.Title = styled.div`
  color: rgb(51, 51, 51);
  line-height: 1;
  font-size: 30px;
  flex-shrink: 0;
  flex-grow: 1;
`;

CardTitle.Link = styled.a`
  color: rgb(34, 167, 240);
  font-size: 24px;
  line-height: 1;
  margin-right: 30px;
  &, &:focus, &:active,
  &:visited, &:hover {
    text-decoration: none !important;
    outline: none !important;
    background: none !important;
  }
`;

const CardContent = styled.div`
  width: 100%;
  padding: 15px 30px;
  display: flex;
  flex-wrap: wrap;
`;

CardContent.Text = styled.span`
  color: rgb(51, 51, 51);
  font-size: 30px;
  line-height: 1;
  margin: 15px 0;
  flex-shrink: 0;
  flex-grow: 0;
  width: 50%;
`;

CardContent.Combined = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
  width: 100%; 
  height: 240px;
  border: 1px solid #f0f0f0;
`;

CardContent.Combined.Text = styled.span`
  font-size: 36px;
  line-height: 42px;
  margin-left: 30px;
  color: rgb(102, 102, 102);
`;

CardContent.Combined.Image = styled.img`
  margin-right: 30px;
`;

const AvatarCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  height: 324px;
`;

AvatarCard.Avatar = styled.img`
  height: 180px;
  width: 180px;
  margin-top: 61px;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
`;

AvatarCard.AvatarText = styled.div`
  font-size: 24px;
  color: rgb(51, 51, 51);
  margin-top: 20px;
  line-height: 1;
`;

AvatarCard.Icon = styled.img`
  position: absolute;
  top: 40px;
  right: 40px;
  width: 53px;
`;

class Me extends TitledComponent {
  componentWillMount() {
    if (!this.props.loggedin) {
      this.props.dispatch(refreshUserInfo());
    }
  }

  toUpdate() {
    this.props.dispatch(setMedicalHistoryInitial([...this.props.info.medical_history]));
    this.props.dispatch(destroy(MEDICAL_HISTORY_FORM_NAME));
    this.props.dispatch(destroy(UPDATE_INFO_FORM_NAME));
    this.goto('/updateinfo');
  }

  renderBMI() {
    const { weight, height } = this.props.info;
    const { bmi, text } = calculateBMI(height, weight);
    return (
      <CardContent.Text style={{ width: '100%' }}>BMI指数: {bmi.toFixed(0)}
        <span style={{
          color: 'rgb(245, 71, 70)'
        }}>（{text}）
        </span>
      </CardContent.Text>
    );
  }

  render() {
    const {
      name, gender, height, weight,
      cellphone, age, avatar,
      report_num: reportNum
    } = this.props.info;

    return (
      <Wrapper>
        <AvatarCard>
          <AvatarCard.Avatar src={avatar || defaultAvatar} />
          <AvatarCard.AvatarText>手机号：{cellphone}</AvatarCard.AvatarText>
          <AvatarCard.Icon src={settingIcon} onClick={() => this.goto('/me/account')} />
        </AvatarCard>

        <Gap />

        <Card>
          <CardTitle>
            <CardTitle.IconContainer>
              <img src={infoIcon}
                alt='个人信息'
                style={{
                width: '54px',
                marginLeft: '30px',
              }} />
            </CardTitle.IconContainer>
            <CardTitle.Title>{name}</CardTitle.Title>
            <CardTitle.Link onClick={() => this.toUpdate()}>修改</CardTitle.Link>
          </CardTitle>
          <CardContent>
            <CardContent.Text>性别: {gender === 1 ? '男' : '女'}</CardContent.Text>
            <CardContent.Text>年龄: {age}岁</CardContent.Text>
            <CardContent.Text>身高: {height}厘米</CardContent.Text>
            <CardContent.Text>体重: {weight}公斤</CardContent.Text>
            {this.renderBMI()}
          </CardContent>
        </Card>

        <Gap />

        <Card style={{ flexGrow: '1' }}>
          <CardTitle>
            <CardTitle.IconContainer>
              <img
                src={reportIcon}
                alt='历史报告'
                style={{
                  width: '37px',
                  marginLeft: '40px',
                }} />
            </CardTitle.IconContainer>
            <CardTitle.Title>历史报告</CardTitle.Title>
          </CardTitle>
          <CardContent>
            <CardContent.Combined>
              <CardContent.Combined.Text>
                <p>您目前</p>
                <p>有
                  <span
                    style={{
                      color: 'rgb(255, 138, 95)',
                      fontSize: '42px',
                    }}>
                    {reportNum}
                  </span>
                份历史报告
                </p>
              </CardContent.Combined.Text>
              <CardContent.Combined.Image
                style={{
                  width: '350px',
                }}
                src={reportImage}
              />
            </CardContent.Combined>
            <LargePrimaryButton
              style={{
              width: '100%'
            }}
              onClick={() => this.goto('/history')}
            >
              查看我的历史报告
            </LargePrimaryButton>
          </CardContent>
        </Card>
      </Wrapper>
    );
  }
}

Me.defaultProps = {
  title: '个人中心',
  info: USER_INFO_PLACEHOLDER,
};

Me.propTypes = {
  ...TitledComponent.propTypes,
  info: PropTypes.object,
  loggedin: PropTypes.bool.isRequired,
};

export default connect(state => ({
  info: state.user.me,
  loggedin: state.user.loggedin,
}))(Me);



// WEBPACK FOOTER //
// ./src/scene/me.jsx